import { c as _c } from "react/compiler-runtime";
import { ListItem, ListItemText, ListItemIcon } from '@mui/material';
import { styled } from '@classify/react-core-components/styles';
import { LearningActivityStatus, ACTIVITY_TYPE } from '../../../learning-activities';
const PREFIX = 'LearningOutcomeListItem';
const classes = {
  root: `${PREFIX}-root`,
  withSmallIcon: `${PREFIX}-withSmallIcon`
};
const StyledListItem = styled(ListItem)(/* istanbul ignore next */({
  theme: {
    spacing
  }
}) => ({
  [`&.${classes.root}`]: {
    padding: 0,
    '& + &': {
      paddingTop: spacing(3)
    }
  },
  [`& .${classes.withSmallIcon}`]: {
    minWidth: 40
  }
}));
export const LearningOutcomeListItem = t0 => {
  const $ = _c(13);
  const {
    title,
    hasSmallIcon: t1,
    status: t2
  } = t0;
  const hasSmallIcon = t1 === undefined ? false : t1;
  const status = t2 === undefined ? "not started" : t2;
  const t3 = hasSmallIcon ? classes.withSmallIcon : null;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      root: t3
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = !hasSmallIcon;
  let t6;
  if ($[2] !== status || $[3] !== t5) {
    t6 = <LearningActivityStatus isBig={t5} status={status} activityType={ACTIVITY_TYPE.LEARNING_OUTCOME} />;
    $[2] = status;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t6) {
    t7 = <ListItemIcon classes={t4}>{t6}</ListItemIcon>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== title) {
    t8 = <ListItemText primary={title} />;
    $[8] = title;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7 || $[11] !== t8) {
    t9 = <StyledListItem className={classes.root}>{t7}{t8}</StyledListItem>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export default LearningOutcomeListItem;